import styled from '@emotion/styled';

import { color } from '../theme';

const _Star = styled.span`
  color: ${color('error')};
  padding-left: 4px;
`;

export const Star = () => <_Star>*</_Star>;
